import {ReactElement} from "react"

const BoatIcon = ():ReactElement => {
	return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.20362 22.7496L0.75 17.9504H22.7494L18.2958 22.7496H5.20362Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1779 15.2243C16.6457 14.6484 13.7278 15.6466 11.8081 16.9904C11.5394 15.9922 11.3858 14.7252 11.2706 13.343C11.0786 10.7323 11.117 7.66081 11.2706 5.05006C11.2706 4.55095 11.3474 4.09022 11.3858 3.6295C11.501 2.4777 11.6161 1.44108 11.7697 0.75C13.6894 5.54917 16.8376 11.1546 20.1395 15.1859L20.1779 15.2243Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8086 17.9892V16.991"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.752 17.9887C21.869 17.144 20.9859 16.1842 20.1797 15.2244"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2698 13.3428C8.39026 13.4963 5.35719 14.7633 2.09375 16.6446C4.55093 11.6151 7.16167 8.50521 11.2698 5.0498C11.1162 7.62216 11.0778 10.6936 11.2698 13.3428Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 17.9883L2.09377 16.6445"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8063 0.788396C11.6528 1.51787 11.4992 2.5161 11.4224 3.6679H5.625L7.65986 2.20894L5.625 0.75H11.8447L11.8063 0.788396Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BoatIcon
